import React from 'react';
import {ModalHeader, ModalBody} from 'reactstrap';
import {useTranslation} from 'react-i18next';
import dompurify from 'dompurify';
import {useApi} from '@/api';
import {blank} from '@/util';
import Icon from '@/views/shared/Icon';
import DownloadFileButton from '@/views/shared/DownloadFileButton';

import PolicyStatement from '@/b2b/pages/PolicyStatement';
import {PopError} from '@/b2b/components/Pop';
import styles from '@/b2b/index.module.css';

const PolicyDetail = ({handleClick, caaId, setContent}) => {
  const {t: tr} = useTranslation('nb');
  const [content, error] = useApi(`/b2b/policy_detail/${caaId}.html`, []);

  if (error) {
    return <PopError error={String(error)} />;
  }

  const InnerHtml = ({html}) => {
    const cleanup = dompurify.sanitize(html);

    const clickClientParty = event => {
      const current = event.target;
      const partyId = current.getAttribute('data-party-id');
      if (current.tagName === 'IMG' && !blank(partyId)) {
        setContent({component: PolicyStatement, partyId});
      }
    };

    return (
      <div
        role='button'
        dangerouslySetInnerHTML={{__html: cleanup}}
        tabIndex={0}
        onClick={clickClientParty}
        onKeyDown={clickClientParty}
        className={styles.modal_outline}
      />
    );
  };

  const pdfDownLoadPath = `/b2b/policy_detail/${caaId}.pdf`;
  const closeBtn = (
    <span
      role='button'
      tabIndex={0}
      className={styles.modal_close}
      onClick={handleClick}
      onKeyDown={handleClick}
    >
      &times;
    </span>
  );

  return (
    <>
      <ModalHeader
        toggle={handleClick}
        close={closeBtn}
        className={styles.modal_header}
      >
        {tr('new_policy_detail')}
      </ModalHeader>
      <ModalBody>
        <DownloadFileButton
          className={`btn btn-outline-primary btn-sm ${styles.btn_sm}`}
          path={pdfDownLoadPath}
        >
          {tr('common:pdf_version')}
          <span>
            {' '}
            <Icon icon='file-pdf' />{' '}
          </span>
        </DownloadFileButton>
        <br />
        <br />
        <InnerHtml html={content} />
      </ModalBody>
    </>
  );
};

export default PolicyDetail;
